import React from 'react';
import eurekaMgrs from '@eureka/ui-managers';
import { List, ListMode, CustomListItem, Icon, Ui5CustomEvent } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import '@ui5/webcomponents-icons/dist/json-imports/Icons.js';
import { UserProfileState } from 'src/types';

const { getThemeId, getThemeList } = eurekaMgrs.AppearanceManager;
const formItemStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

type Props = {
  data: UserProfileState;
  theme: languages[];
  onDataPropChange: (value: string, propName: string) => void;
};
interface languages {
  displayLanguageCode: string;
  language: string;
}

const UserAppearance: React.FC<Props> = ({ onDataPropChange }) => {
  const [currentTheme, setCurrentTheme] = React.useState(getThemeId());
  return (
    <div style={formItemStyle}>
      <List
        id="theme-setting"
        // TODO:
        // value={getThemeId()}
        mode={ListMode.SingleSelect}
        onSelectionChange={(
          evt: Ui5CustomEvent<
            HTMLElement,
            {
              selectedItems: any[];
              previouslySelectedItems: any[];
            }
          >,
        ) => {
          const themeId = evt.detail?.selectedItems[0]?.dataset.id;
          console.log(`Theme Id is ${themeId}`);
          setCurrentTheme(themeId);
          onDataPropChange(themeId, 'themeId');
        }}
        style={{ width: '100%', height: '330px' }}
        data-testid="select-theme-id"
      >
        {getThemeList().map((theme, i) => {
          return (
            <CustomListItem
              key={theme.themeId + '-option'}
              // TODO:
              // value={theme.themeId}
              // tooltip={theme.displayName}
              selected={getThemeId() === theme.themeId}
              style={{ width: '100%', height: '68px', paddingRight: '10px' }}
              data-id={theme.themeId}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '85px' }}>
                  <div
                    style={{
                      ...theme.style,
                      width: '2.5rem',
                      height: '2.5rem',
                      borderRadius: '100%',
                      margin: 'auto',
                    }}
                  ></div>
                </div>
                <div
                  data-testid={'select-theme-id-' + i}
                  style={{
                    width: '260px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '68px',
                    color: ThemingParameters.sapTextColor,
                    paddingRight: '5px',
                  }}
                >
                  {theme.displayName}
                </div>
                {currentTheme === theme.themeId && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      background: ThemingParameters.sapSelectedColor,
                      margin: '0 10px',
                    }}
                  >
                    <Icon
                      name="accept"
                      style={{
                        width: '12px',
                        height: '12px',
                        color: ThemingParameters.sapContent_ForegroundColor,
                      }}
                    />
                  </div>
                )}
              </div>
            </CustomListItem>
          );
        })}
      </List>
    </div>
  );
};

export default UserAppearance;
